module.exports = __webpack_public_path__ + "img/dff767f3745fc8d752ca2f6e7daa70a6.png";